export function isCardExpired(expirationDate?: string): boolean {
    if (!expirationDate) return false;
    const [year, month]: number[] = expirationDate.split('-').map(Number);
    const now: Date = new Date();
    const expiry: Date = new Date(year, month, 0); // Last day of expiry month
    return expiry < now;
}

export function isCardExpiringSoon(expirationDate?: string): boolean {
    if (!expirationDate || isCardExpired(expirationDate)) return false;
    const [year, month]: number[] = expirationDate.split('-').map(Number);
    const now: Date = new Date();
    const expiry: Date = new Date(year, month, 0);
    const daysUntilExpiry: number = Math.ceil(
        (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
    );
    return daysUntilExpiry <= 30;
}
